import React from 'react'
import emi from '../component/assets/emi-calculator.png';
import pincode from '../component/assets/pincode.png';
import { Helmet } from "react-helmet-async";



function ToolsMenu() {
  return (
    <>

      <Helmet>
      <title>HushStory Tools - Make Tools Accessible.</title>
      <meta name="description"
      content="We believe that stories are the best way to communicate ideas, and we want to make sure everyone has access to them. Whether it's a meme, blog or a conversation you overheard in a coffee shop."
      data-rh="true"/>
      </Helmet>




    <div className='container justify-content-center text-center' style={{marginTop: '30px' , padding: "70px"}}>
      <h1>HushStory-Tools</h1>
      <p>Tools Which Helps you in Solving your Day to day problems</p>
    <div className='d-flex align-content-stretch justify-content-around flex-wrap'>
        <div>
        <a href='/emi-calculator'><img src={emi} style={{ width:"40%" , minWidth:"290px" , margin:"10px"}} alt='Emi-calculator-tool-img'/></a>
        <a href='/search-pincode'><img src={pincode} style={{ width:"40%" , minWidth:"290px" , margin:"10px" }} alt='search-Pincode-tool-img'/></a>
        </div>
    </div>

    </div>
    </>
  )
}

export default ToolsMenu